// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ltklHBey6NAdFakh {
	margin-left: 12px;
	background-color: #4D87BE;
	color: #fff;
	font-weight: 500;
	font-size: 16px;
	width: fit-content;
	padding: 0 15px;
	height: 35px;
	border-radius: 200px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.Bu4tqZqRnZYa48Vy {
	max-width: 1310px;
	margin: 0 auto;
	padding-bottom: 96px;
}

.Bu4tqZqRnZYa48Vy h2 {
	color: #303030;
	font-size: 30px;
	font-weight: 600;
	margin: 0;
}

.hiwgnrQ3SNEDiEUN {
	margin-top: 20px;
	width: 450px;
	height: 58px;
	padding: 12px 10px;
	border-radius: 16px;
	box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
	background: #FFFFFF;
}

.wYlireiiQd8h1Xjx {
	margin: 29px 0 30px 0;
}

.Bu4tqZqRnZYa48Vy .p-datatable-table {
	border-radius: 16px;
	overflow: hidden;
}

.Bu4tqZqRnZYa48Vy .p-datatable-thead th {
	background-color: #f2e1bc;
	border: 1px solid #f3f5f7;
	padding: 18px 30px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-thead th:first-child > div {
	display: flex;
	justify-content: flex-start;
}

.Bu4tqZqRnZYa48Vy .p-datatable-thead th > div {
	display: flex;
	justify-content: center;
	color: #303030;
	font-size: 18px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody td {
	border: 1px solid #f3f5f7;
	padding: 9px 8px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td:first-child {
	text-align: left;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td {
	text-align: center;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .tAsG4ArJCUcR28sl {
	background-color: #e1e7ed;
}

.tAsG4ArJCUcR28sl {
	padding: 28px 22px;
	border-radius: 6px;
}

.CYHs3RBbuTEDtiYR {
	width: 114px;
	height: 67px;
}

.CYHs3RBbuTEDtiYR:hover {
	background-color: #E1E7ED;
	border-radius: 6px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .CYHs3RBbuTEDtiYR {
	background-color: #e1e7ed;
}

.E7189gkaO_4mqojn {
	display: flex;
	gap: 8px;
	justify-content: center;
	align-items: center;
}

.xzej2dn7Go1WAi2J,
.J9Et5Af6yrs9MUHw,
.Ej0zrMPNEq0M942M {
	width: 75px;
	height: 67px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .xzej2dn7Go1WAi2J {
	background-color: #c5f3c1;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .J9Et5Af6yrs9MUHw {
	background-color: #e1e7ed;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .Ej0zrMPNEq0M942M {
	background-color: #ffcaca;
}

.xzej2dn7Go1WAi2J span::before {
	color: #56be4d;
	font-size: 20px;
}

.Ej0zrMPNEq0M942M span::before {
	color: #dd0000;
	font-size: 20px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .xzej2dn7Go1WAi2J span::before {
	color: #185625;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr:hover .J9Et5Af6yrs9MUHw span::before {
	color: #20336c;
}

.J9Et5Af6yrs9MUHw span::before {
	color: #4d87be;
	font-size: 20px;
}

.z0_cYvS6lIEwMDlW {
	color: #000000;
	background-color: transparent;
	border: none;
}

.z0_cYvS6lIEwMDlW i {
	font-size: 16px;
	background-color: #f2e1bc;
	padding: 10px;
	border-radius: 8px;
	margin-left: 12px;
}

.sU8IcNXAJ8OYd_gy {
	width: 100%;
	background-color: #DD0000;
	border-radius: 16px;
	padding: 18px 20px;
	font-size: 20px;
	font-weight: 600;
	color: #ffffff;
	border: none;
}

.sU8IcNXAJ8OYd_gy:hover {
	background-color: #721010;
}

.oh0xqp_powRkVybG {
	width: 100%;
	background-color: #F3F5F7;
	border-radius: 16px;
	padding: 10px 20px;
	color: #4D87BE;
	font-size: 20px;
	font-weight: 600;
	border: none;
}

.oh0xqp_powRkVybG:hover {
	color: #305375;
}

.aCKiBqYnsC7SVALi {
	width: 541px !important;
	height: 354px !important;
	background-color: #F3F5F7;
	border-radius: 25px !important;
}

.aCKiBqYnsC7SVALi .p-dialog {
	border-radius: 25px !important;
	background-color: #F3F5F7;
}

.aCKiBqYnsC7SVALi .p-dialog-footer {
	border-bottom-right-radius: 25px !important;
	border-bottom-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.aCKiBqYnsC7SVALi .p-dialog-header {
	border-top-right-radius: 25px !important;
	border-top-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.aCKiBqYnsC7SVALi .p-dialog-content{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.aCKiBqYnsC7SVALi .hbdNZCCnedodrX8B {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-size: 20px;
	font-weight: 400;
}

.aCKiBqYnsC7SVALi .p-dialog-title {
	font-size: 30px !important;
	font-weight: 700 !important;
}

.aCKiBqYnsC7SVALi .p-dialog-content {
	background-color: #F3F5F7;
}

.xgxc_mi4DIkuMN_r {
	width: 100%;
	background-color: #56be4d;
	border-radius: 16px;
	padding: 18px 0px;
	color: #ffffff;
	border: none;
	font-size: 20px;
	font-weight: 600;
}

.xgxc_mi4DIkuMN_r:hover {
	background-color: #185625;
}

.PMuH6KDWezkNqrje {
	width: 674px !important;
	height: fit-content;
	background-color: #F3F5F7;
	border-radius: 16px !important;
}

.PMuH6KDWezkNqrje .p-dialog {
	border-radius: 16px !important;
}

.PMuH6KDWezkNqrje .p-dialog-footer {
	border-bottom-right-radius: 16px !important;
	border-bottom-left-radius: 16px !important;
	background-color: #F3F5F7;
}

.PMuH6KDWezkNqrje .p-dialog-header {
	border-top-right-radius: 16px !important;
	border-top-left-radius: 16px !important;
	background-color: #F3F5F7;
}

.PMuH6KDWezkNqrje .p-dialog-title {
	font-size: 30px !important;
	font-weight: 700 !important;
}

.PMuH6KDWezkNqrje .p-dialog-content {
	background-color: #F3F5F7;
}

.PMuH6KDWezkNqrje .field label {
	font-size: 20px !important;
	font-weight: 400 !important;
}

.yNPlFgtbFAp0cAnh {
	border-radius: 16px;
	font-size: 18px;
	padding: 14px 20px;
	background-color: #ffffff;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.ougPFFb_2Yzmu1TS {
	border-radius: 16px 0 0 16px !important;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.v63Y1uFiqCMACvep {
	border-radius: 0 16px 16px 0 !important;
	background-color: #ffffff;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.GtHE_wxoCwsn8axP {
	margin-bottom: 52px;
	width: 100%;
}

.GtHE_wxoCwsn8axP .p-dropdown-trigger {
	margin-right: 10px;
}

.GtHE_wxoCwsn8axP .p-dropdown {
	width: 100% !important;
	text-align: left;
	border-radius: 16px;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);;
	border: none;
}

.GtHE_wxoCwsn8axP .p-dropdown-label {
	display: block;
	padding: 14px 20px;
	font-size: 18px;
	font-family: "Roboto";
}

.fd4VjhwCI7ov0M7J {
	border-radius: 24px;
	border: 1px solid #a4a4a4;
	overflow: hidden;
	padding: 16px 20px;
}

.fd4VjhwCI7ov0M7J .p-dropdown-items-wrapper {
	max-height: 400px !important;
}

.fd4VjhwCI7ov0M7J .p-dropdown-items li {
	height: 40px;
	border-radius: 15px;
	margin: 4px 0;
	font-size: 18px;
	color: #303030;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
	border: 2px solid transparent;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
	border: 2px solid #20336c;
	background-color: inherit;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
	background-color: inherit;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item.p-highlight {
	color: #ffffff;
	background-color: #20336c;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item.p-highlight:after {
	content: "✓";
	position: absolute;
	right: 16px;
	font-size: 24px;
	color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/UserManagement.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,4CAA4C;CAC5C,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;;;CAGC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,aAAa;CACb,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,sGAAsG;AACvG;;AAEA;CACC,uCAAuC;CACvC,sGAAsG;AACvG;;AAEA;CACC,uCAAuC;CACvC,yBAAyB;CACzB,sGAAsG;AACvG;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,mBAAmB;CACnB,sGAAsG;CACtG,YAAY;AACb;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,cAAc;AACf;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,cAAc;AACf","sourcesContent":[".organizationLabel {\r\n\tmargin-left: 12px;\r\n\tbackground-color: #4D87BE;\r\n\tcolor: #fff;\r\n\tfont-weight: 500;\r\n\tfont-size: 16px;\r\n\twidth: fit-content;\r\n\tpadding: 0 15px;\r\n\theight: 35px;\r\n\tborder-radius: 200px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.pageWrapper {\r\n\tmax-width: 1310px;\r\n\tmargin: 0 auto;\r\n\tpadding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n\tcolor: #303030;\r\n\tfont-size: 30px;\r\n\tfont-weight: 600;\r\n\tmargin: 0;\r\n}\r\n\r\n.dropdown {\r\n\tmargin-top: 20px;\r\n\twidth: 450px;\r\n\theight: 58px;\r\n\tpadding: 12px 10px;\r\n\tborder-radius: 16px;\r\n\tbox-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n\tbackground: #FFFFFF;\r\n}\r\n\r\n.header {\r\n\tmargin: 29px 0 30px 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n\tbackground-color: #f2e1bc;\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tcolor: #303030;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n\ttext-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n\ttext-align: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .cellInsider {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n\tpadding: 28px 22px;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.activeBtn {\r\n\twidth: 114px;\r\n\theight: 67px;\r\n}\r\n\r\n.activeBtn:hover {\r\n\tbackground-color: #E1E7ED;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .activeBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cellSoundWrapper {\r\n\tdisplay: flex;\r\n\tgap: 8px;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn {\r\n\twidth: 75px;\r\n\theight: 67px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn {\r\n\tbackground-color: #c5f3c1;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .deleteBtn {\r\n\tbackground-color: #ffcaca;\r\n}\r\n\r\n.playBtn span::before {\r\n\tcolor: #56be4d;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n\tcolor: #dd0000;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn span::before {\r\n\tcolor: #185625;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn span::before {\r\n\tcolor: #20336c;\r\n}\r\n\r\n.soundBtn span::before {\r\n\tcolor: #4d87be;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.createBtn {\r\n\tcolor: #000000;\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n}\r\n\r\n.createBtn i {\r\n\tfont-size: 16px;\r\n\tbackground-color: #f2e1bc;\r\n\tpadding: 10px;\r\n\tborder-radius: 8px;\r\n\tmargin-left: 12px;\r\n}\r\n\r\n.deleteDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #DD0000;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 20px;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n\tbackground-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px;\r\n\tpadding: 10px 20px;\r\n\tcolor: #4D87BE;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tborder: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n\tcolor: #305375;\r\n}\r\n\r\n.deleteModal {\r\n\twidth: 541px !important;\r\n\theight: 354px !important;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n\tborder-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 25px !important;\r\n\tborder-bottom-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 25px !important;\r\n\tborder-top-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content){\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tflex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttext-align: center;\r\n\tfont-size: 20px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n\tfont-size: 30px !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.saveBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #56be4d;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 0px;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n\tbackground-color: #185625;\r\n}\r\n\r\n.userModal {\r\n\twidth: 674px !important;\r\n\theight: fit-content;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px !important;\r\n}\r\n\r\n.userModal :global(.p-dialog) {\r\n\tborder-radius: 16px !important;\r\n}\r\n\r\n.userModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 16px !important;\r\n\tborder-bottom-left-radius: 16px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.userModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 16px !important;\r\n\tborder-top-left-radius: 16px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.userModal :global(.p-dialog-title) {\r\n\tfont-size: 30px !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n.userModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.userModal :global(.field) label {\r\n\tfont-size: 20px !important;\r\n\tfont-weight: 400 !important;\r\n}\r\n\r\n.input {\r\n\tborder-radius: 16px;\r\n\tfont-size: 18px;\r\n\tpadding: 14px 20px;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.phonePrefix {\r\n\tborder-radius: 16px 0 0 16px !important;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.inputPhone {\r\n\tborder-radius: 0 16px 16px 0 !important;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.dropDownWrapper {\r\n\tmargin-bottom: 52px;\r\n\twidth: 100%;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-trigger) {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n\twidth: 100% !important;\r\n\ttext-align: left;\r\n\tborder-radius: 16px;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);;\r\n\tborder: none;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n\tdisplay: block;\r\n\tpadding: 14px 20px;\r\n\tfont-size: 18px;\r\n\tfont-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n\tborder-radius: 24px;\r\n\tborder: 1px solid #a4a4a4;\r\n\toverflow: hidden;\r\n\tpadding: 16px 20px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n\tmax-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n\theight: 40px;\r\n\tborder-radius: 15px;\r\n\tmargin: 4px 0;\r\n\tfont-size: 18px;\r\n\tcolor: #303030;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n\tborder: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n\tborder: 2px solid #20336c;\r\n\tbackground-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n\tbackground-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n\tcolor: #ffffff;\r\n\tbackground-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n\tcontent: \"✓\";\r\n\tposition: absolute;\r\n\tright: 16px;\r\n\tfont-size: 24px;\r\n\tcolor: #ffffff;\r\n}"],"sourceRoot":""}]);
// Exports
export var organizationLabel = `ltklHBey6NAdFakh`;
export var pageWrapper = `Bu4tqZqRnZYa48Vy`;
export var dropdown = `hiwgnrQ3SNEDiEUN`;
export var header = `wYlireiiQd8h1Xjx`;
export var cellInsider = `tAsG4ArJCUcR28sl`;
export var activeBtn = `CYHs3RBbuTEDtiYR`;
export var cellSoundWrapper = `E7189gkaO_4mqojn`;
export var playBtn = `xzej2dn7Go1WAi2J`;
export var soundBtn = `J9Et5Af6yrs9MUHw`;
export var deleteBtn = `Ej0zrMPNEq0M942M`;
export var createBtn = `z0_cYvS6lIEwMDlW`;
export var deleteDialogBtn = `sU8IcNXAJ8OYd_gy`;
export var cancelDialogBtn = `oh0xqp_powRkVybG`;
export var deleteModal = `aCKiBqYnsC7SVALi`;
export var text = `hbdNZCCnedodrX8B`;
export var saveBtn = `xgxc_mi4DIkuMN_r`;
export var userModal = `PMuH6KDWezkNqrje`;
export var input = `yNPlFgtbFAp0cAnh`;
export var phonePrefix = `ougPFFb_2Yzmu1TS`;
export var inputPhone = `v63Y1uFiqCMACvep`;
export var dropDownWrapper = `GtHE_wxoCwsn8axP`;
export var dropDownPanel = `fd4VjhwCI7ov0M7J`;
export default ___CSS_LOADER_EXPORT___;
